export const ESC_KEYCODE = 27;
